module.exports = __webpack_public_path__ + "static/img/19090D_1_R_20201117_fit.50a26fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19090D_1_R_20201117_fit.png
// module id = mOhH
// module chunks = 0